export enum Rol {
  ADMIN_EMPRESAS = 1,
  COLABORADOR = 2,
  SUPERVISOR = 3,
  ASISTENTE = 4,
}


// colaborador: solo acceso a la app movil (si es la aplicacion movil osea la instalada en el telefono) y en la web que muestre el acceso a proyectos y encuestas (solo crear editar y ver sin acceso a a eliminar)
// Supervisor: acceso a seguridad y accesos, proyectos, encuestas (accesos a todas las opciones editar, crear, ver , eliminar)
// Asistente: acceso a seguridad y accesos, proyectos, encuestas pero no puede eliminar
// Admin Principal: acceso solo a los modulos de multiempresa y seguridad accesos
// Admin Empresas: acceso a todos los modulos

// la parte de que muestre la info de la aplicacion movil es solo cuando es instalada en el telefono
